export const MAX_CONTAINER_WIDTH = "xl:w-[1236px]";
